import { render, staticRenderFns } from "./AddPrinter.vue?vue&type=template&id=47827126&scoped=true&"
import script from "./AddPrinter.vue?vue&type=script&lang=js&"
export * from "./AddPrinter.vue?vue&type=script&lang=js&"
import style0 from "./AddPrinter.vue?vue&type=style&index=0&id=47827126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47827126",
  null
  
)

export default component.exports